import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  }
}));

const CompanyToolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row} fullWidth>
        <SearchInput
          className={classes.searchInput}
          placeholder="شرکت مورد نظر را جستجو کنید"
        />
      </div>
    </div>
  );
};

CompanyToolbar.propTypes = {
  className: PropTypes.string
};

export default CompanyToolbar;
